import {useEffect, useState} from "react";

/**
 * Returns true while the viewport is at or below `breakpoint` px.
 *
 * Drives the Reports page's responsive rendering: desktop keeps the dense
 * react-data-table-component grid, while phones/tablets get a purpose-built
 * card list (see {@link ReportTable}). Uses matchMedia so it reacts to
 * rotation / resize without a scroll/resize listener storm.
 */
export default function useIsMobile(breakpoint = 768) {
  const query = `(max-width: ${breakpoint}px)`;

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    // Safari < 14 only supports the deprecated addListener API.
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);

  return isMobile;
}
